export default __webpack_public_path__ + "d9513f95195f7f5805dcdf0603db39b8.svg";